import { notifyDanger } from '@gandi/notifications';
import { createLogger } from 'gandi.redux-logger';
import { addCartProduct, removeCartBundle, removeCartProduct, removeCartProducts } from '../../../../../middleware/actions';
import { addDiscount, addProductOptimistic, getCart, removeProductOptimistic } from '../../../../../modules/actions';
import { selectCartUUID } from '../../../../../modules/selectors';
import { resource as suggestionResource, removeSuggestionOptimistic } from '../../../../../modules/suggest/actions';
import { suggestionToProductData, suggestionToOptimistic } from '../helpers';
export const removeProductFactory = ({
  translator: {
    __
  },
  product,
  dispatch
}) => evt => {
  evt.preventDefault();
  const productIds = product.ids || [product.id];
  if (productIds.length === 1) {
    return dispatch(removeCartProduct(product.id, {
      optimistic: false
    })).catch(err => {
      const message = err._error || __('Unable to remove the product from the Cart.');
      return dispatch(notifyDanger({
        message
      }));
    }).finally(() => {
      dispatch(getCart());
    });
  }
  return dispatch(removeCartProducts(productIds.map(id => ({
    id
  })))).catch(err => {
    const message = err._error || __('Unable to remove the product from the Cart.');
    return notifyDanger({
      message
    });
  }).finally(() => dispatch(getCart()));
};
export const removeBundleFactory = ({
  translator: {
    __
  },
  bundle,
  dispatch
}) => async evt => {
  evt.preventDefault();
  try {
    await dispatch(removeCartBundle(bundle.id));
  } catch (err) {
    const message = __('Unable to remove the bundle from the cart.');
    notifyDanger({
      message
    });
  } finally {
    dispatch(getCart()).catch(() => {});
  }
};
export const addProductSuggestionToCart = productSuggestion => async (dispatch, getState) => {
  const cartId = selectCartUUID(getState());
  dispatch(addProductOptimistic(suggestionToOptimistic(productSuggestion)));
  if (productSuggestion.discount_code) {
    try {
      await dispatch(addDiscount(productSuggestion.discount_code));
    } catch (e) {
      const logger = createLogger('suggestionLogger');
      logger.error(e, `Cannot add ${productSuggestion.discount_code} to cart`);
    }
  }
  dispatch(removeSuggestionOptimistic({
    cartId,
    suggestionId: productSuggestion.suggestionId
  }));
  try {
    const response = await dispatch(addCartProduct({
      productData: suggestionToProductData(productSuggestion),
      extra: {
        optimisticId: productSuggestion.suggestionId
      },
      options: {
        headers: {
          'X-Orga-Reset': 0
        }
      }
    }));
    return response;
  } catch (e) {
    dispatch(removeProductOptimistic(productSuggestion.suggestionId));
    if (e.response?.status !== 409) {
      throw e;
    }
    return e.response;
  } finally {
    dispatch(suggestionResource.invalidate());
    dispatch(getCart());
  }
};